/**
 * {@docCategory Tooltip}
 */
export var TooltipDelay;
(function (TooltipDelay) {
  TooltipDelay[TooltipDelay["zero"] = 0] = "zero";
  /** 300 ms delay before showing the tooltip */
  TooltipDelay[TooltipDelay["medium"] = 1] = "medium";
  /** 500 ms delay before showing the tooltip */
  TooltipDelay[TooltipDelay["long"] = 2] = "long";
})(TooltipDelay || (TooltipDelay = {}));